import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../../components/Sidebar";
import HeaderContent from "../../components/Header";
import FormStrip from "../../components/FormStrip";
import SubStep1 from "./Step1/SubStep1";
import SubStep2 from "./Step1/SubStep2";
import { citizenBaseUrl, LTPSidebarlabels, MSSidebarlabels } from "../../components/data";
import {
  MainWrapper,
  PortalWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  SideWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../components/StyledComponent";
import { useTranslation } from "react-i18next";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import getMapSubmissionData from "./getMapSubmissionData";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
// import { validateSummaryForm } from "../../../../utils/summaryFormValidation";
import { validateSummaryForm } from "../../../../../utils/summaryFormValidation";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import SubStep3 from "./Step1/SubStep3";
import SubStep4 from "./Step1/SubStep4";
import Step2 from "./Step2";
import ReactToPrint from "react-to-print";
import ButtonWrapper from "../../components/Button";
import { Card } from "@mui/material";
import SearchSummary from "./Summary/SearchSummary";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { BackButton, Toast } from "@egovernments/digit-ui-react-components";
import Step4 from "./Step4";
import Step5 from "./Step5";
import SubStep5 from "./Step1/SubStep5";
import Step6 from "./Step6";
import { useLocation } from "react-router-dom";
import LandUseNOC from "../../../../../components/LandUseNOC/LandUseNOC";
import IdentifyNoc from "../../reusableComponents/IdentifyNoc";
import NOCInfo from "../../../../employee/NOC/NOCInfo";
import NOCTakeAction from "@egovernments/digit-ui-module-common/src/sharedComponents/NOCTakeAction";
import CompoundingChecklist from "@egovernments/digit-ui-module-common/src/sharedComponents/CompoundingChecklist";
import Step4Comp from "./Step4Comp";
import SubStep6 from "./Step1/SubStep6";
import { departmentList } from "../../../TCPForms/data";
import ChatBoard from "../../../../../components/ChatBoard";

/** Normalises any date value to "YYYY-MM-DD" for the backend. */
const formatDateToYMD = (value) => {
  if (!value) return value;
  // Already in YYYY-MM-DD format
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const d = new Date(value);
  if (isNaN(d.getTime())) return value; // return as-is if unparseable
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const MapSubmissionPortal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const reduxDocs = useSelector((state) => state.formMTDoc?.documents || state.formMT?.documents || []);
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { id } = useParams();
  // For a new application (no id), never restore stale tab state from a previous session
  const isNewApplication = !id;
  const [activeTab, setActiveTab] = useState(isNewApplication ? 0 : Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(isNewApplication ? 0 : Digit?.SessionStorage.get("MS_CURRENT_SUBTAB") || 0);
  const [summaryShow, setSummaryshow] = useState(isNewApplication ? false : Digit?.SessionStorage.get("SUMMARY_TAB") || false);
  const [showToast, setShowToast] = useState(null);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [isAlreadySubmitted, setIsAlreadySubmitted] = useState("No");
  const [obpasFileNumber, setObpasFileNumber] = useState("");
  const [dateOfPayment, setDateOfPayment] = useState("");
  const [paymentReceipt, setPaymentReceipt] = useState(null);
  const applicationFlow = Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
  const scrutinyFlow = Digit.SessionStorage.get("LTP.SCRUTINY.SELECTION") || null;
  const Modal = useModal();

  const tenantId = Digit.ULBService.getStateId();
  const info = Digit.UserService.getUser()?.info;
  const userType = info?.type;
  const isEmployee = userType === "EMPLOYEE";
  const history = useHistory();
  const location = useLocation();
  let applicationData = location.state?.data;
  console.log(applicationData, "applicationDataadatabefore");
  let isAppDataLoading = false;
  if (!applicationData) {
    ({ applicationData, isAppDataLoading } = getMapSubmissionData(t, id));
  }
  console.log(applicationData, "applicationDataadataafter");
  const isSelfCert = applicationData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  //const { applicationData, isAppDataLoading } = getMapSubmissionData(t, id);
  const componentRef = useRef();
  const subTabLabels = [
    { label: "General Information" },
    { label: "Plot Details" },
    { label: "Applicant Information" },
    { label: "Geo Location" },
    { label: "NOC Status" },
    { label: "Land/Plot Information" },
  ];
  const closeToast = () => {
    setShowToast(null);
  };
  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_MAP_SUBMISSION", applicationData);
  console.log("parmsfromPortalMapSubmission", params, params?.nocList?.length);

  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams((prev) => ({
        ...prev,
        ...data,
        mapSubDetails: {
          ...prev?.mapSubDetails,
          ...data?.mapSubDetails,
        },
      }));
    } else if (key === "") {
      setParams((prev) => ({
        ...prev,
        ...data,
        mapSubDetails: {
          ...prev?.mapSubDetails,
          ...data?.mapSubDetails,
        },
      }));
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  useEffect(() => {
    if (id && applicationData && applicationData?.applicationNo) {
      // Hard-overwrite params with fresh API data.
      // NOC-related fields (nocList, nocDetails) are always taken from the
      // API response so the NOC Status tab never shows stale session data.
      setParams((prev) => ({
        ...prev,
        ...applicationData,
        // Force-replace NOC data from fresh API — do NOT merge with prev.
        nocList: applicationData?.nocList || [],
        nocDetails: applicationData?.nocDetails || prev?.nocDetails,
        mapSubDetails: {
          ...prev?.mapSubDetails,
          ...applicationData?.mapSubDetails,
        },
      }));

      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
    // Re-run whenever a new application's data arrives (applicationNo changes)
    // or the loading state settles — covers both query-fetch and location.state flows.
  }, [id, isAppDataLoading, applicationData?.applicationNo]);

  // Clear stale session storage on mount.
  // - For new applications: clear everything.
  // - For edit flow: immediately wipe FORM_MAP_SUBMISSION so the
  //   useSessionStorage hook does not seed params with stale data from a
  //   previous session; fresh API data will re-populate it via the effect below.
  useEffect(() => {
    if (isNewApplication) {
      clearParams();
      resetFormMTDocs();
      Digit.SessionStorage.del("MS_CURRENT_TAB");
      Digit.SessionStorage.del("MS_CURRENT_SUBTAB");
      Digit.SessionStorage.del("SUMMARY_TAB");
    } else {
      // Edit mode: wipe the stale form data so fresh API response wins.
      // Tab/sub-tab positions are intentionally kept so the user lands on
      // the correct tab after returning to the application.
      clearParams();
    }
  }, []); // Run only once on mount

  const isCompounding = params?.natureOfConstruction === "Compounding";
  const isCompletionModule = params?.applicationType === "FORM_COMPLETION";
  console.log("hhjjkkklll", isCompounding);

  const handleTabChange = async (nextTabNo, formData = null, makePayment = false) => {
    // Always validate before allowing navigation to Summary (tab 4 non-compounding / tab 5 compounding) or submission
    const isSummaryNav = !isCompounding ? nextTabNo >= 4 : nextTabNo >= 5;
    if (isSummaryNav || makePayment) {
      const dataToValidate = formData ? { ...params, ...formData } : params;
      console.log("[VALIDATION DEBUG] reduxDocs:", reduxDocs);
      console.log("[VALIDATION DEBUG] formData.documents:", dataToValidate?.documents);
      console.log("[VALIDATION DEBUG] natureOfConstruction:", dataToValidate?.natureOfConstruction);
      console.log("[VALIDATION DEBUG] professionaldetails:", dataToValidate?.professionaldetails);
      // Strip documents from formData: only trust reduxDocs (current session uploads)
      // params.documents may contain stale data from a previous session in storage
      const validation = validateSummaryForm({
        formType: "FORM_MAP_SUBMISSION",
        formData: { ...dataToValidate, documents: [] },
        reduxDocuments: reduxDocs,
        declarationChecked: makePayment ? declarationChecked : true,
        t,
      });
      console.log("[VALIDATION DEBUG] result:", validation.isValid, validation.errors);
      if (!validation.isValid) {
        Modal("Missing Mandatory Fields", validation.errorHtml, "error");
        return;
      }
    }
    if (formData) {
      const data = { ...params, ...formData };
      if (data?.mapSubDetails?.prevFileNo) {
        data.prevFileNo = data.mapSubDetails.prevFileNo;
      }
      if (data?.mapSubDetails?.sanctionValidityDate) {
        data.sanctionValidityDate = formatDateToYMD(data.mapSubDetails.sanctionValidityDate);
        data.mapSubDetails.sanctionValidityDate = data.sanctionValidityDate;
      }
      if (data?.mapSubDetails?.sanctionValidityStartDate) {
        data.sanctionValidityStartDate = formatDateToYMD(data.mapSubDetails.sanctionValidityStartDate);
        data.mapSubDetails.sanctionValidityStartDate = data.sanctionValidityStartDate;
      }
      console.log("fromHandleTabchange", data, formData, nextTabNo, isCompounding);

      // (Validation already ran above for summary nav / makePayment - no duplicate check needed here)

      const isSelfCert = params?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
      try {
        let paymentReceipt = formData?.documents?.find((item) => item?.documentType === "PaymentReceipt")?.fileStoreId;
        if (
          data?.isAlreadySubmitted &&
          formData?.obpasFileNumber &&
          formData?.obpasPaymentDate &&
          paymentReceipt &&
          params?.status !== "REVERT_TO_APPLICANT"
        ) {
          data.workflow = {
            action: "FORWARD_TO_DEPARTMENT",
            assignes: null,
          };
        } else if (
          (nextTabNo === 5 && !isCompounding && params?.status !== "REVERT_TO_APPLICANT") ||
          (nextTabNo === 6 && isCompounding && params?.status !== "REVERT_TO_APPLICANT")
        ) {
          if (params?.isGovernmentBuilding === "yes") {
            data.workflow = {
              action: "FORWARD_TO_DEPARTMENT",
              assignes: null,
            };
          } else {
            data.workflow = {
              action: isSelfCert ? "MAKE_PAYMENT_SELF" : "MAKE_PAYMENT",
              assignes: null,
            };
          }
        } else if (nextTabNo === 5 && params?.status === "REVERT_TO_APPLICANT") {
          data.workflow = {
            action: "FORWARD_TO_DEPARTMENT",
            assignes: null,
          };
        } else {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null,
          };
        }

        console.log("DataBEFORESUBM", data);

        updateApiCall.mutate(
          { BPA: data },
          {
            onSuccess: () => {
              onSelect("", data);
              if (makePayment) {
                if (params?.status === "REVERT_TO_APPLICANT" || data?.isAlreadySubmitted || params?.isGovernmentBuilding === "yes") {
                  Modal(
                    "Application Submited",
                    `Your Application ${params?.applicationNo} has been sent to department for further approval`,
                    "success"
                  );
                } else {
                  if (isSelfCert) {
                    history.push(
                      `/digit-ui/citizen/payment/collect/BPA.MAP_SELF_FEE/${`${formData?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  } else if (params?.taxHeadEstimates?.length > 1) {
                    history.push(
                      `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[1]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  } else {
                    history.push(
                      `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[0]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  }
                  //   Modal(
                  //     "Application Submited",
                  //     `Your Application ${params?.applicationNo} has been sent to the plot Owner for his consent`,
                  //     "success"
                  //   );
                  // }
                  clearParams();
                  Digit.SessionStorage.del("FORM_MAP_SUBMISSION");
                  Digit?.SessionStorage.del("EDCR_CREATE");
                  Digit?.SessionStorage.del("FASTPAS_ID");
                  Digit?.SessionStorage.del("SUMMARY_TAB");
                  setTimeout(() => {
                    resetFormMTDocs();
                  }, 0);
                  Digit.SessionStorage.del("MS_CURRENT_TAB");
                  Digit.SessionStorage.del("MS_CURRENT_SUBTAB");
                  //history.push(`${citizenBaseUrl}/profile`);
                }
              } else {
                if (nextTabNo === 5) {
                  Digit.SessionStorage.set("SUMMARY_TAB", true);
                  setSummaryshow(true);
                }
                //  Modal(
                //   "Application Updated",
                //   `Application Updated Successfully!`,
                //   "success"
                // )

                setShowToast({ error: false, message: `Data has been saved successfully` });
                setActiveTab(nextTabNo);
                Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
                // setActiveTab(nextTabNo);
                // Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo)
              }
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            },
          }
        );
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    if (nextTabNo === 5) {
      Digit.SessionStorage.set("SUMMARY_TAB", true);
      setSummaryshow(true);
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };

  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
      if (data?.mapSubDetails?.prevFileNo) {
        data.prevFileNo = data.mapSubDetails.prevFileNo;
      }
      if (data?.mapSubDetails?.sanctionValidityDate) {
        data.sanctionValidityDate = formatDateToYMD(data.mapSubDetails.sanctionValidityDate);
        data.mapSubDetails.sanctionValidityDate = data.sanctionValidityDate;
      }
      if (data?.mapSubDetails?.sanctionValidityStartDate) {
        data.sanctionValidityStartDate = formatDateToYMD(data.mapSubDetails.sanctionValidityStartDate);
        data.mapSubDetails.sanctionValidityStartDate = data.sanctionValidityStartDate;
      }
      //Removing scrutiny===EDCR condition as per discussion with team since scrutiny flow is not decided yet and it is not impacting any flow as of now. It can be added back once the scrutiny flow is finalized.
      if (activeTab === 0 && selectedSubTab === 0 && !isSelfCert && !isCompounding && !id && data?.scrutinyFlow === "EDCR") {
        data.scrutinyFlow = "EDCR";
        data.riskType = "HIGH";
        //Adding hardcoded value for scrutinyFlow as EDCR since there is no clarity on scrutiny flow and it is not impacting any flow as of now. It can be removed or modified once the scrutiny flow is finalized.
        Digit.OBPSService.create({ BPA: data }, tenantId)
          .then((res) => {
            if (res?.BPA?.length > 0) {
              const createdBpa = res?.BPA?.[0] || {};
              const mergedData = {
                ...data,
                ...createdBpa,
                natureOfConstruction: createdBpa?.natureOfConstruction || data?.natureOfConstruction,
                prevFileNo: createdBpa?.prevFileNo || data?.prevFileNo || data?.mapSubDetails?.prevFileNo,
                sanctionValidityDate: createdBpa?.sanctionValidityDate || data?.sanctionValidityDate || data?.mapSubDetails?.sanctionValidityDate,
                sanctionValidityStartDate:
                  createdBpa?.sanctionValidityStartDate || data?.sanctionValidityStartDate || data?.mapSubDetails?.sanctionValidityStartDate,
                mapSubDetails: {
                  ...data?.mapSubDetails,
                  ...createdBpa?.mapSubDetails,
                  prevFileNo: createdBpa?.prevFileNo || data?.prevFileNo || data?.mapSubDetails?.prevFileNo,
                  sanctionValidityDate: createdBpa?.sanctionValidityDate || data?.sanctionValidityDate || data?.mapSubDetails?.sanctionValidityDate,
                  sanctionValidityStartDate:
                    createdBpa?.sanctionValidityStartDate || data?.sanctionValidityStartDate || data?.mapSubDetails?.sanctionValidityStartDate,
                },
              };
              onSelect("", mergedData, true);
              setShowToast({
                error: false,
                message: `Application Created Successfully!`,
              });
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
            }
          })
          .catch((e) => {
            Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
          });
      } else {
        try {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
          updateApiCall.mutate(
            { BPA: data },
            {
              onSuccess: (res) => {
                const updatedBpa = res?.BPA?.[0] || {};
                const mergedData = {
                  ...data,
                  ...updatedBpa,
                  natureOfConstruction: updatedBpa?.natureOfConstruction || data?.natureOfConstruction,
                  prevFileNo: updatedBpa?.prevFileNo || data?.prevFileNo || data?.mapSubDetails?.prevFileNo,
                  sanctionValidityDate: updatedBpa?.sanctionValidityDate || data?.sanctionValidityDate || data?.mapSubDetails?.sanctionValidityDate,
                  sanctionValidityStartDate:
                    updatedBpa?.sanctionValidityStartDate || data?.sanctionValidityStartDate || data?.mapSubDetails?.sanctionValidityStartDate,
                  mapSubDetails: {
                    ...data?.mapSubDetails,
                    ...updatedBpa?.mapSubDetails,
                    prevFileNo: updatedBpa?.prevFileNo || data?.prevFileNo || data?.mapSubDetails?.prevFileNo,
                    sanctionValidityDate: updatedBpa?.sanctionValidityDate || data?.sanctionValidityDate || data?.mapSubDetails?.sanctionValidityDate,
                    sanctionValidityStartDate:
                      updatedBpa?.sanctionValidityStartDate || data?.sanctionValidityStartDate || data?.mapSubDetails?.sanctionValidityStartDate,
                  },
                };
                onSelect("", mergedData);
                setShowToast({ error: false, message: `Data has been saved successfully` });
                setSelectedSubTab(nextSubTab);
                Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
              },
              onError: () => {
                Modal("Update Error", "Something went wrong!!", "error");
              },
            }
          );
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
    }
  };

  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return (
            <SubStep1
              formData={params}
              handleSubTabChange={handleSubTabChange}
              setFormData={setParams}
              handleTabChange={handleTabChange}
              initFormMTDocs={initFormMTDocs}
              setShowToast={setShowToast}
              isEmployee={isEmployee}
            />
          );
        case 1:
          return <SubStep3 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 2:
          return <SubStep2 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 3:
          return <SubStep4 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 4:
          return (
            <React.Fragment>
              {/* While the edit-flow API fetch is still in progress (isAppDataLoading),
                  or while params hasn't been hydrated with fresh data yet (no applicationNo),
                  show a loading indicator so we don't flash IdentifyNoc incorrectly. */}
              {id && (isAppDataLoading || !params?.applicationNo) ? (
                <div style={{ textAlign: "center", padding: "40px" }}>
                  <span>Loading NOC data...</span>
                </div>
              ) : params?.nocList?.length > 0 ? (
                <NOCTakeAction
                  formData={params}
                  onNocUpdate={(updatedNocList) => {
                    setParams((prev) => ({
                      ...prev,
                      nocList: updatedNocList,
                      nocDetails: {
                        ...(prev?.nocDetails || {}),
                        nocListApplicantDoc: updatedNocList,
                      },
                    }));
                  }}
                />
              ) : (
                <IdentifyNoc
                  formData={params}
                  tenantId={tenantId}
                  handleTabChange={handleTabChange}
                  handleSubTabChange={handleSubTabChange}
                  isEmployee={isEmployee}
                />
              )}
            </React.Fragment>
          );
        case 5:
          return (
            <SubStep6
              formData={params}
              handleSubTabChange={handleSubTabChange}
              handleTabChange={handleTabChange}
              t={t}
              tenantId={tenantId}
              departmentList={departmentList}
              avpData={null}
              isEmployee={isEmployee}
              isApproved={true}
            />
          );

        // return <LandUseNOC formData={params} role={"CITIZEN"} handleTabChange={handleTabChange} Modal={Modal} />;
        // <SubStep5 formData={params} role="APPROVED_CITIZEN" handleTabChange={handleTabChange} handleSubTabChange={handleSubTabChange} isEmployees={isEmployee}/>;
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return <Step2 formData={params} handleTabChange={handleTabChange} tenantId={tenantId} isEmployee={isEmployee} />;
    } else if (activeTab === 2 && isCompounding) {
      return <CompoundingChecklist formData={params} handleTabChange={handleTabChange} />;
    } else if (activeTab === 2 && !isCompounding) {
      return <Step4 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
    } else if (activeTab === 3 && isCompounding) {
      return <Step4Comp formData={params} handleTabChange={handleTabChange} />;
    } else if (activeTab === 3 && !isCompounding) {
      return <Step5 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
    } else if (activeTab === 4 && isCompounding) {
      return <Step5 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
    } else if ((activeTab === 4 && !isCompounding) || (activeTab === 5 && isCompounding)) {
      return (
        <div>
          <Card style={{ width: "90%", margin: "0 auto" }} ref={componentRef}>
            <SearchSummary
              id={params?.applicationNo}
              ref={componentRef}
              handleDeclarationChange={handleDeclarationChange}
              declarationChecked={declarationChecked}
              showDeclaration={true}
              isAlreadySubmitted={isAlreadySubmitted}
              setIsAlreadySubmitted={setIsAlreadySubmitted}
              obpasFileNumber={obpasFileNumber}
              setObpasFileNumber={setObpasFileNumber}
              dateOfPayment={dateOfPayment}
              setDateOfPayment={setDateOfPayment}
              paymentReceipt={paymentReceipt}
              setPaymentReceipt={setPaymentReceipt}
            />
            <div
              style={{
                margin: "20px",
                padding: "12px 16px",
                backgroundColor: "#fff3cd",
                border: "1px solid #ffeeba",
                borderRadius: "4px",
                color: "#856404",
                fontWeight: "500",
              }}
            >
              {t("FASTPAS.GLOBAL.ONCE.TEXT")}
            </div>
          </Card>
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ReactToPrint
                trigger={() => (
                  <ButtonWrapper variant="contained" color="success" size="medium" label="Print" sx={{ backgroundColor: "#7600bc" }}>
                    Print Summary
                  </ButtonWrapper>
                )}
                content={() => componentRef.current}
              />
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Preview"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleTabChange(0)}
              />
              {isAlreadySubmitted === "Yes" ? (
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Save"
                  type="submit"
                  sx={{ backgroundColor: "#157CB3", width: "180px" }}
                  onClick={() => {
                    const updatedParams = {
                      ...params,
                      isAlreadySubmitted: true,
                      obpasFileNumber,
                      obpasPaymentDate: dateOfPayment,
                    };
                    if (paymentReceipt?.fileStoreId) {
                      updatedParams.documents = [
                        ...(updatedParams.documents || []),
                        {
                          documentType: "PaymentReceipt",
                          fileStoreId: paymentReceipt.fileStoreId,
                          tenantId: tenantId,
                        },
                      ];
                    }
                    handleTabChange(isCompounding ? 6 : 5, updatedParams, true);
                  }}
                  disabled={!declarationChecked || (!isCompletionModule && (!obpasFileNumber || !dateOfPayment || !paymentReceipt))}
                />
              ) : (
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label={
                    params?.status === "REVERT_TO_APPLICANT" || params?.isGovernmentBuilding === "yes" ? "Forward to Department" : "Make Payment"
                  }
                  type="submit"
                  sx={{ backgroundColor: "#157CB3", width: "180px" }}
                  onClick={() => handleTabChange(isCompounding ? 6 : 5, params, true)}
                  disabled={!declarationChecked}
                />
              )}
            </div>
          </div>
        </div>
      );
    } else if ((activeTab === 6 && isCompounding) || (activeTab === 5 && !isCompounding)) {
      return <Step6 formData={params} handleSubTabChange={handleTabChange} />;
    } else if (activeTab === 7 && isCompounding) {
      return (
        <React.Fragment>
          <ChatBoard formData={params} assignerToChatboard={[]} />
        </React.Fragment>
      );
    }
    // else if(activeTab === 4){
    //   return <Step5 formData={params} handleSubTabChange={handleTabChange}/>
    // }
  };

  console.log("activeTab.........", activeTab);
  return (
    <MainWrapper>
      {/* <HeaderContent applicationFlow={applicationFlow} /> */}
      <BackButton />
      <FormStrip formName={t("Map Submission")} />
      <PrimaryTabsWrapper>
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
          <PrimaryTab label="Application Form" />
          <PrimaryTab label="Document" />
          {isCompounding && <PrimaryTab label="Compounding Checklist" />}
          <PrimaryTab label="Drawing Details" />
          <PrimaryTab label="Fees" />
          <PrimaryTab label="Summary" />
          <PrimaryTab label="Application History" />
          {isCompounding && <PrimaryTab label="Chat Board" />}
          {/* <PrimaryTab label="Letter and Plan" /> */}
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      {/* <StyledDivider /> */}
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default MapSubmissionPortal;
